import uniq from 'lodash/uniq';
/**
 * 获取open信息
 * @param {*} _flights 所有航段
 * @param {*} _psgs 勾选的旅客
 */
export default function hasOPEN(_flights, _segmentIds, _psgs) {
    var flightNumList = [];
    _flights.forEach(function (ite) {
        if (ite.valid) {
            flightNumList.push(ite.segmentId);
        }
        ;
    });
    var opFlightNoList = [];
    _psgs.forEach(function (params) {
        if (Array.isArray(params.openSegmentList) && params.openSegmentList.length) {
            params.openSegmentList.forEach(function (item) {
                if (flightNumList.includes(item)) {
                    opFlightNoList.push(item);
                }
                ;
            });
        }
        ;
    });
    _psgs.forEach(function (params) {
        if (Array.isArray(params.openSegmentList) && params.openSegmentList.length) {
            params.openSegmentList = opFlightNoList;
        }
        ;
    });
    var segmentIds = uniq(_psgs
        .filter(function (psg) {
        return Array.isArray(psg.openSegmentList) && psg.openSegmentList.length;
    })
        .map(function (psg) {
        return psg.openSegmentList;
    })
        .reduce(function (p, n) {
        return p.concat(n);
    }, [])
        .filter(function (seg) {
        return _segmentIds.indexOf(Number(seg)) === -1;
    }));
    var flights = _flights.filter(function (flight) {
        return segmentIds.indexOf(flight.segmentId) !== -1;
    });
    return {
        segmentIds: segmentIds,
        flights: flights,
    };
}



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/business/hasOPEN.js
// module id = null
// module chunks = 